/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Drawer } from 'antd'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import QRCode from 'qrcode.react'
import ReactToPrint from 'react-to-print'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false
		}
		
		this.handleDownload = this.handleDownload.bind(this)
	}

	handleDownload(e) {
		e.preventDefault()
		const { selectedOfficer } = this.props

		const visitorSplittedName = selectedOfficer.full_name.split(' ')
		const visitorFirstname = visitorSplittedName[0]
		const visitorLastName = visitorSplittedName[visitorSplittedName.length - 1]
		const visitorFilename = `QRCode_${visitorFirstname}${visitorLastName.substring(0,1)}_${moment().format('YYYYMMDDHHmmss')}`
		const canvas = document.getElementById('generated-qr')
		const pngUrl = canvas
			.toDataURL('image/png')
			.replace('image/png', 'image/octet-stream')
		let downloadLink = document.createElement('a')
		downloadLink.href = pngUrl
		downloadLink.download = `${visitorFilename}.png`
		document.body.appendChild(downloadLink)
		downloadLink.click()
		document.body.removeChild(downloadLink)
	}

	render() {
		const { visible, onClose, selectedOfficer } = this.props
		
		const qrCodeData = {
			uid: selectedOfficer.uid,
			full_name: selectedOfficer.full_name,
			user_type: 'EMPLOYEE',
			work_at: 'Lamao Barangay Council',
			designation: selectedOfficer.position_name
		}
		return (
			<Drawer
				title='View QR Code'
				placement="right"
				// closable={false}
				onClose={onClose}
				visible={visible}
				width={'35%'}
			>
				<Row style={{ textAlign: 'center' }}>
					<h3>{selectedOfficer.full_name}</h3>
					<div className='qr-code' ref={el => (this.componentRef = el)}>
						<QRCode 
							id='generated-qr' 
							value={JSON.stringify(qrCodeData)}
							size={350}
							level={'H'}
							includeMargin={true}
						/>
					</div>
				</Row>
				<div
					style={{
						position: 'absolute',
						right: 0,
						bottom: 10,
						width: '100%',
						borderTop: '1px solid #e9e9e9',
						padding: '10px 16px',
						background: '#fff',
						textAlign: 'center',
					}}
				>
					<button type="button" className="btn btn-block btn-primary btn-rounded waves-effect waves-light" onClick={this.handleDownload}>Download QR Code</button>
				</div>
				{/* <ReactToPrint
					trigger={() => {
						return <a href="#">Print this out!</a>
					}}
					content={() => this.componentRef}
				/> */}
			</Drawer>
		)
	}
}

const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Index)
